import styled from "styled-components";
import fipayFonts from "../../../../theme/index";
import { colors } from "../../../../theme/color";
import {
  coldWhite_bg_Review,
  quotes_tab,
  quotes_tab2,
  mobileQuote,
  quoteBg_Normalwhite,
  quoteBg_coldWhite,
} from "../../../../../public/assets";

interface StyledComponentProps {
  QuotePath: string;
}

export const QuoteContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  /* width: 530px;
  height: 400px;
  background: url("/assets/svg/Review_background_coldwhite.png");
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  box-shadow: 0px 4px 76.5999984741211px 0px #e7e7e740;
  box-sizing: border-box;
  padding: 35px 4px 2px 54px;

  border: 2px solid blue; */

  /* @media screen and (max-width: 768px) {
    width: 453px;
    height: 200px;
    background: url("/assets/svg/new_quotes_Tab.png");
    background-size: cover;
    padding: 25px 4px 2px 24px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  } */

  /* @media screen and (max-width: 375px) {
    width: 270px;
    height: 411px;
    background: url("/assets/svg/mobile_quote.png");
    background-size: cover;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 18px 4px 2px 24px;
    gap: 20px;
  } */
`;

export const QuoteHolder = styled.div<StyledComponentProps>`
  /* width: 380px;
  height: 250px; */
  width: 453px;
  height: 280px;
  background: url(${(props) => props.QuotePath});
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  /* gap: 20px; */
  box-shadow: 0px 4px 76.5999984741211px 0px #e7e7e740;
  /* box-sizing: border-box; */
  padding: 45px 4px 2px 25px;

  /* border: 2px solid blue; */

  @media screen and (max-width: 768px) {
    width: 453px;
    height: 300px;
    background: url(${(props) => props.QuotePath});
    /* background: url("/assets/svg/new_quotes_Tab.png"); */
    background-size: contain;
    background-repeat: no-repeat;
    padding: 25px 4px 2px 24px;
    /* display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px; */
  }

  @media screen and (max-width: 430px) {
    width: 270px;
    height: 343px;
    /* background: url("/assets/svg/mobile_quote.png");
    background-size: cover; */
    background-size: cover;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 18px 4px 2px 24px;
    /* gap: 20px; */
  }
  @media screen and (max-width: 375px) {
    width: 270px;
    height: 343px;
    /* background: url("/assets/svg/mobile_quote.png");
    background-size: cover; */
    background-size: cover;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 18px 4px 2px 24px;
    /* gap: 20px; */
  }
  @media screen and (max-width: 320px) {
    width: 230px;
    height: 343px;
    /* background: url("/assets/svg/mobile_quote.png");
    background-size: cover; */
    background-size: cover;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 18px 4px 2px 24px;
    /* gap: 20px; */
  }
`;

export const QuotesUp = styled.img`
  display: flex;
  width: 30px;
  height: 30px;
  /* justify-content: flex-start;
  align-items: center;
  flex-shrink: 0; */

  @media screen and (max-width: 768px) {
    width: 36px;
    height: 36px;
  }

  @media screen and (max-width: 430px) {
    width: 24px;
    height: 24px;
    margin-top: 10px;
    /* width: 216px;
    height: 38px;
    padding-top: 10px; */
  }
  @media screen and (max-width: 375px) {
    width: 24px;
    height: 24px;
    margin-top: 10px;
    /* width: 216px;
    height: 38px;
    padding-top: 10px; */
  }
  @media screen and (max-width: 320px) {
    width: 24px;
    height: 24px;
    margin-top: 10px;
    /* width: 216px;
    height: 38px;
    padding-top: 10px; */
  }
`;

export const QuoteDown = styled.img`
  display: flex;
  width: 30px;
  height: 30px;
  justify-content: flex-end;
  align-items: center;
  flex-shrink: 0;
  margin-left: 380px;

  @media screen and (max-width: 768px) {
    width: 36px;
    height: 36px;
  }

  @media screen and (max-width: 430px) {
    z-index: 11;
    width: 24px;
    height: 24px;
    margin-left: 530px;
    /* width: 216px;
    height: 38px;
    padding-top: 10px; */
  }
  @media screen and (max-width: 375px) {
    z-index: 11;
    width: 24px;
    height: 24px;
    margin-left: 530px;
    /* width: 216px;
    height: 38px;
    padding-top: 10px; */
  }
  @media screen and (max-width: 320px) {
    z-index: 11;
    width: 24px;
    height: 24px;
    margin-left: 430px;
    /* width: 216px;
    height: 38px;
    padding-top: 10px; */
  }
`;

export const SubtitleText = styled.div`
  width: 370px;
  height: 144px;
  text-align: left;
  font-size: ${fipayFonts.fipayFonts.body2.size};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
  color: ${colors.DARK_GRAY};
  margin: 10px 0 10px 20px;

  @media screen and (max-width: 768px) {
    width: 370px;
    height: 144px;
    font-size: ${fipayFonts.fipayFonts.body2.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
    /* margin-top: 30px;
    margin-bottom: 20px; */
  }

  @media screen and (max-width: 430px) {
    width: 233px;
    height: 200px;
    font-size: ${fipayFonts.fipayFonts.body3.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
  }

  @media screen and (max-width: 375px) {
    width: 233px;
    height: 220px;
    font-size: ${fipayFonts.fipayFonts.body3.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
    padding-left: 10px;
    margin: 0;
  }
  @media screen and (max-width: 320px) {
    width: 210px;
    height: 220px;
    font-size: ${fipayFonts.fipayFonts.body3.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
    padding-left: 10px;
    margin: 0;
  }
`;

export const DetailsSection = styled.div`
  width: 202px;
  height: 60px;
  gap: 8px;
  display: flex;
  align-items: flex-start;
  gap: 5px;
  /* margin-top: 70px; */
  /* border: 1px solid blueviolet; */
  @media screen and (max-width: 375px) {
    width: 157px;
    height: 38px;
  }
`;

export const DetailsAvatar = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 60px;
  /* background: url(<path-to-image>), lightgray 50% / cover no-repeat; */
  @media screen and (max-width: 768px) {
    /* width: 310px;
    height: 60px;
    padding-top: 10px; */
  }

  @media screen and (max-width: 375px) {
    width: 38px;
    height: 38px;
  }
`;

export const DetailsText = styled.div`
  width: 134px;
  height: 60px;
  /* border: 2px solid red; */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  /* gap: 4px; */
  @media screen and (max-width: 375px) {
    width: 157px;
    height: 38px;
  }
`;

export const DetailsTitleText = styled.div`
  text-align: left;
  font-size: ${fipayFonts.fipayFonts.body2.size};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
  line-height: ${fipayFonts.fipayFonts.lineHeight.heading3};
  color: ${colors.BLACK};

  /* @media screen and (max-width: 1024px) {
    font-size: ${fipayFonts.fipayFonts.heading2.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: left;
  } */
  @media screen and (max-width: 768px) {
    font-size: ${fipayFonts.fipayFonts.body2.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.heading3};
    text-align: left;
  }

  @media screen and (max-width: 430px) {
    font-size: ${fipayFonts.fipayFonts.fontSize.body3};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    text-align: left;
  }

  @media screen and (max-width: 375px) {
    font-size: ${fipayFonts.fipayFonts.fontSize.body3};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    text-align: left;
  }
`;

export const DetailsSubtitleText = styled.div`
  text-align: left;
  font-size: ${fipayFonts.fipayFonts.body2.size};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  line-height: ${fipayFonts.fipayFonts.lineHeight.body1};
  color: ${colors.DARK_GRAY};

  @media screen and (max-width: 768px) {
    width: 485px;
    height: 48px;
    font-size: ${fipayFonts.fipayFonts.body2.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
  }

  @media screen and (max-width: 430px) {
    width: 320px;
    height: 48px;
    font-size: ${fipayFonts.fipayFonts.body3.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
  }

  @media screen and (max-width: 375px) {
    font-size: ${fipayFonts.fipayFonts.body3.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
  }
`;
